module.exports = __webpack_public_path__ + "static/media/mail.78afa753.svg";